/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorldRouteImport } from './routes/world'
import { Route as UiShowcaseRouteImport } from './routes/ui-showcase'
import { Route as RelayTestRouteImport } from './routes/relay-test'
import { Route as AboutRouteImport } from './routes/about'
import { Route as gameRouteRouteImport } from './routes/(game)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TermsOfServiceIndexRouteImport } from './routes/terms-of-service/index'
import { Route as ResponsibleGamingPolicyIndexRouteImport } from './routes/responsible-gaming-policy/index'
import { Route as PrivacyPolicyIndexRouteImport } from './routes/privacy-policy/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as LandingPageIndexRouteImport } from './routes/landing-page/index'
import { Route as ArenaIndexRouteImport } from './routes/arena/index'
import { Route as OnboardingLoginRouteImport } from './routes/onboarding/login'
import { Route as OnboardingCreateWalletRouteImport } from './routes/onboarding/create-wallet'
import { Route as gameTopPerformersRouteImport } from './routes/(game)/top-performers'
import { Route as gameSquadRouteImport } from './routes/(game)/squad'
import { Route as gamePvpRouteImport } from './routes/(game)/pvp'
import { Route as gameProfileRouteImport } from './routes/(game)/profile'
import { Route as gameHomeRouteImport } from './routes/(game)/home'
import { Route as gameCreateTournamentRouteImport } from './routes/(game)/create-tournament'
import { Route as gameCreateSquadRouteImport } from './routes/(game)/create-squad'
import { Route as gameCreateChampionshipRouteImport } from './routes/(game)/create-championship'
import { Route as gameWinnerTakesAllIndexRouteImport } from './routes/(game)/winner-takes-all/index'
import { Route as gameVipProgramIndexRouteImport } from './routes/(game)/vip-program/index'
import { Route as gameTournamentIndexRouteImport } from './routes/(game)/tournament/index'
import { Route as gameTerminalIndexRouteImport } from './routes/(game)/terminal/index'
import { Route as gameShopIndexRouteImport } from './routes/(game)/shop/index'
import { Route as gameRushIndexRouteImport } from './routes/(game)/rush/index'
import { Route as gameReferrerIndexRouteImport } from './routes/(game)/referrer/index'
import { Route as gameReferralsIndexRouteImport } from './routes/(game)/referrals/index'
import { Route as gamePracticeIndexRouteImport } from './routes/(game)/practice/index'
import { Route as gameMissionsIndexRouteImport } from './routes/(game)/missions/index'
import { Route as gameLuckyDrawIndexRouteImport } from './routes/(game)/lucky-draw/index'
import { Route as gameLeaderboardIndexRouteImport } from './routes/(game)/leaderboard/index'
import { Route as gameKothIndexRouteImport } from './routes/(game)/koth/index'
import { Route as gameInventoryIndexRouteImport } from './routes/(game)/inventory/index'
import { Route as gameHostedTournamentIndexRouteImport } from './routes/(game)/hosted-tournament/index'
import { Route as gameGrandRushIndexRouteImport } from './routes/(game)/grand-rush/index'
import { Route as gameGachaIndexRouteImport } from './routes/(game)/gacha/index'
import { Route as gameGachaTaskIndexRouteImport } from './routes/(game)/gacha-task/index'
import { Route as gameEventIndexRouteImport } from './routes/(game)/event/index'
import { Route as gameChangelogIndexRouteImport } from './routes/(game)/changelog/index'
import { Route as gameChampionshipIndexRouteImport } from './routes/(game)/championship/index'
import { Route as gameWinnerTakesAllHistoryRouteImport } from './routes/(game)/winner-takes-all/history'
import { Route as gameWinnerTakesAllTournamentIdRouteImport } from './routes/(game)/winner-takes-all/$tournamentId'
import { Route as gameTournamentTournamentIdRouteImport } from './routes/(game)/tournament/$tournamentId'
import { Route as gameRushLeaderboardRouteImport } from './routes/(game)/rush/leaderboard'
import { Route as gameRushHistoryRouteImport } from './routes/(game)/rush/history'
import { Route as gamePracticeLeaderboardRouteImport } from './routes/(game)/practice/leaderboard'
import { Route as gamePracticeHistoryRouteImport } from './routes/(game)/practice/history'
import { Route as gameMissionsOnetimeMissionRouteImport } from './routes/(game)/missions/onetime-mission'
import { Route as gameMissionsDailyMissionRouteImport } from './routes/(game)/missions/daily-mission'
import { Route as gameMatchHistoryRouteImport } from './routes/(game)/match/history'
import { Route as gameMatchSeedRouteImport } from './routes/(game)/match/$seed'
import { Route as gameKothLeaderboardRouteImport } from './routes/(game)/koth/leaderboard'
import { Route as gameKothHistoryRouteImport } from './routes/(game)/koth/history'
import { Route as gameKothKothIdRouteImport } from './routes/(game)/koth/$kothId'
import { Route as gameHostedTournamentTournamentIdRouteImport } from './routes/(game)/hosted-tournament/$tournamentId'
import { Route as gameGrandRushLeaderboardRouteImport } from './routes/(game)/grand-rush/leaderboard'
import { Route as gameGrandRushHistoryRouteImport } from './routes/(game)/grand-rush/history'
import { Route as gameGachaHistoryRouteImport } from './routes/(game)/gacha/history'
import { Route as gameChampionshipTournamentIdRouteImport } from './routes/(game)/championship/$tournamentId'
import { Route as gamePrivateChampionshipTournamentIdIndexRouteImport } from './routes/(game)/private-championship/$tournamentId/index'
import { Route as gameLuckyDrawHistoryIndexRouteImport } from './routes/(game)/lucky-draw/history/index'
import { Route as gamePrivateChampionshipTournamentIdMatchIdRouteImport } from './routes/(game)/private-championship/$tournamentId/$matchId'
import { Route as gameLuckyDrawHistoryDrawIdRouteImport } from './routes/(game)/lucky-draw/history/$drawId'

const WorldRoute = WorldRouteImport.update({
  id: '/world',
  path: '/world',
  getParentRoute: () => rootRouteImport,
} as any)
const UiShowcaseRoute = UiShowcaseRouteImport.update({
  id: '/ui-showcase',
  path: '/ui-showcase',
  getParentRoute: () => rootRouteImport,
} as any)
const RelayTestRoute = RelayTestRouteImport.update({
  id: '/relay-test',
  path: '/relay-test',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const gameRouteRoute = gameRouteRouteImport.update({
  id: '/(game)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceIndexRoute = TermsOfServiceIndexRouteImport.update({
  id: '/terms-of-service/',
  path: '/terms-of-service/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResponsibleGamingPolicyIndexRoute =
  ResponsibleGamingPolicyIndexRouteImport.update({
    id: '/responsible-gaming-policy/',
    path: '/responsible-gaming-policy/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PrivacyPolicyIndexRoute = PrivacyPolicyIndexRouteImport.update({
  id: '/privacy-policy/',
  path: '/privacy-policy/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingPageIndexRoute = LandingPageIndexRouteImport.update({
  id: '/landing-page/',
  path: '/landing-page/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArenaIndexRoute = ArenaIndexRouteImport.update({
  id: '/arena/',
  path: '/arena/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingLoginRoute = OnboardingLoginRouteImport.update({
  id: '/onboarding/login',
  path: '/onboarding/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingCreateWalletRoute = OnboardingCreateWalletRouteImport.update({
  id: '/onboarding/create-wallet',
  path: '/onboarding/create-wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const gameTopPerformersRoute = gameTopPerformersRouteImport.update({
  id: '/top-performers',
  path: '/top-performers',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameSquadRoute = gameSquadRouteImport.update({
  id: '/squad',
  path: '/squad',
  getParentRoute: () => gameRouteRoute,
} as any)
const gamePvpRoute = gamePvpRouteImport.update({
  id: '/pvp',
  path: '/pvp',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameProfileRoute = gameProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameHomeRoute = gameHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameCreateTournamentRoute = gameCreateTournamentRouteImport.update({
  id: '/create-tournament',
  path: '/create-tournament',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameCreateSquadRoute = gameCreateSquadRouteImport.update({
  id: '/create-squad',
  path: '/create-squad',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameCreateChampionshipRoute = gameCreateChampionshipRouteImport.update({
  id: '/create-championship',
  path: '/create-championship',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameWinnerTakesAllIndexRoute = gameWinnerTakesAllIndexRouteImport.update({
  id: '/winner-takes-all/',
  path: '/winner-takes-all/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameVipProgramIndexRoute = gameVipProgramIndexRouteImport.update({
  id: '/vip-program/',
  path: '/vip-program/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameTournamentIndexRoute = gameTournamentIndexRouteImport.update({
  id: '/tournament/',
  path: '/tournament/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameTerminalIndexRoute = gameTerminalIndexRouteImport.update({
  id: '/terminal/',
  path: '/terminal/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameShopIndexRoute = gameShopIndexRouteImport.update({
  id: '/shop/',
  path: '/shop/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameRushIndexRoute = gameRushIndexRouteImport.update({
  id: '/rush/',
  path: '/rush/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameReferrerIndexRoute = gameReferrerIndexRouteImport.update({
  id: '/referrer/',
  path: '/referrer/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameReferralsIndexRoute = gameReferralsIndexRouteImport.update({
  id: '/referrals/',
  path: '/referrals/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gamePracticeIndexRoute = gamePracticeIndexRouteImport.update({
  id: '/practice/',
  path: '/practice/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameMissionsIndexRoute = gameMissionsIndexRouteImport.update({
  id: '/missions/',
  path: '/missions/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameLuckyDrawIndexRoute = gameLuckyDrawIndexRouteImport.update({
  id: '/lucky-draw/',
  path: '/lucky-draw/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameLeaderboardIndexRoute = gameLeaderboardIndexRouteImport.update({
  id: '/leaderboard/',
  path: '/leaderboard/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameKothIndexRoute = gameKothIndexRouteImport.update({
  id: '/koth/',
  path: '/koth/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameInventoryIndexRoute = gameInventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameHostedTournamentIndexRoute =
  gameHostedTournamentIndexRouteImport.update({
    id: '/hosted-tournament/',
    path: '/hosted-tournament/',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameGrandRushIndexRoute = gameGrandRushIndexRouteImport.update({
  id: '/grand-rush/',
  path: '/grand-rush/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameGachaIndexRoute = gameGachaIndexRouteImport.update({
  id: '/gacha/',
  path: '/gacha/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameGachaTaskIndexRoute = gameGachaTaskIndexRouteImport.update({
  id: '/gacha-task/',
  path: '/gacha-task/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameEventIndexRoute = gameEventIndexRouteImport.update({
  id: '/event/',
  path: '/event/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameChangelogIndexRoute = gameChangelogIndexRouteImport.update({
  id: '/changelog/',
  path: '/changelog/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameChampionshipIndexRoute = gameChampionshipIndexRouteImport.update({
  id: '/championship/',
  path: '/championship/',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameWinnerTakesAllHistoryRoute =
  gameWinnerTakesAllHistoryRouteImport.update({
    id: '/winner-takes-all/history',
    path: '/winner-takes-all/history',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameWinnerTakesAllTournamentIdRoute =
  gameWinnerTakesAllTournamentIdRouteImport.update({
    id: '/winner-takes-all/$tournamentId',
    path: '/winner-takes-all/$tournamentId',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameTournamentTournamentIdRoute =
  gameTournamentTournamentIdRouteImport.update({
    id: '/tournament/$tournamentId',
    path: '/tournament/$tournamentId',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameRushLeaderboardRoute = gameRushLeaderboardRouteImport.update({
  id: '/rush/leaderboard',
  path: '/rush/leaderboard',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameRushHistoryRoute = gameRushHistoryRouteImport.update({
  id: '/rush/history',
  path: '/rush/history',
  getParentRoute: () => gameRouteRoute,
} as any)
const gamePracticeLeaderboardRoute = gamePracticeLeaderboardRouteImport.update({
  id: '/practice/leaderboard',
  path: '/practice/leaderboard',
  getParentRoute: () => gameRouteRoute,
} as any)
const gamePracticeHistoryRoute = gamePracticeHistoryRouteImport.update({
  id: '/practice/history',
  path: '/practice/history',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameMissionsOnetimeMissionRoute =
  gameMissionsOnetimeMissionRouteImport.update({
    id: '/missions/onetime-mission',
    path: '/missions/onetime-mission',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameMissionsDailyMissionRoute =
  gameMissionsDailyMissionRouteImport.update({
    id: '/missions/daily-mission',
    path: '/missions/daily-mission',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameMatchHistoryRoute = gameMatchHistoryRouteImport.update({
  id: '/match/history',
  path: '/match/history',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameMatchSeedRoute = gameMatchSeedRouteImport.update({
  id: '/match/$seed',
  path: '/match/$seed',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameKothLeaderboardRoute = gameKothLeaderboardRouteImport.update({
  id: '/koth/leaderboard',
  path: '/koth/leaderboard',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameKothHistoryRoute = gameKothHistoryRouteImport.update({
  id: '/koth/history',
  path: '/koth/history',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameKothKothIdRoute = gameKothKothIdRouteImport.update({
  id: '/koth/$kothId',
  path: '/koth/$kothId',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameHostedTournamentTournamentIdRoute =
  gameHostedTournamentTournamentIdRouteImport.update({
    id: '/hosted-tournament/$tournamentId',
    path: '/hosted-tournament/$tournamentId',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameGrandRushLeaderboardRoute =
  gameGrandRushLeaderboardRouteImport.update({
    id: '/grand-rush/leaderboard',
    path: '/grand-rush/leaderboard',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameGrandRushHistoryRoute = gameGrandRushHistoryRouteImport.update({
  id: '/grand-rush/history',
  path: '/grand-rush/history',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameGachaHistoryRoute = gameGachaHistoryRouteImport.update({
  id: '/gacha/history',
  path: '/gacha/history',
  getParentRoute: () => gameRouteRoute,
} as any)
const gameChampionshipTournamentIdRoute =
  gameChampionshipTournamentIdRouteImport.update({
    id: '/championship/$tournamentId',
    path: '/championship/$tournamentId',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gamePrivateChampionshipTournamentIdIndexRoute =
  gamePrivateChampionshipTournamentIdIndexRouteImport.update({
    id: '/private-championship/$tournamentId/',
    path: '/private-championship/$tournamentId/',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameLuckyDrawHistoryIndexRoute =
  gameLuckyDrawHistoryIndexRouteImport.update({
    id: '/lucky-draw/history/',
    path: '/lucky-draw/history/',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gamePrivateChampionshipTournamentIdMatchIdRoute =
  gamePrivateChampionshipTournamentIdMatchIdRouteImport.update({
    id: '/private-championship/$tournamentId/$matchId',
    path: '/private-championship/$tournamentId/$matchId',
    getParentRoute: () => gameRouteRoute,
  } as any)
const gameLuckyDrawHistoryDrawIdRoute =
  gameLuckyDrawHistoryDrawIdRouteImport.update({
    id: '/lucky-draw/history/$drawId',
    path: '/lucky-draw/history/$drawId',
    getParentRoute: () => gameRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/relay-test': typeof RelayTestRoute
  '/ui-showcase': typeof UiShowcaseRoute
  '/world': typeof WorldRoute
  '/create-championship': typeof gameCreateChampionshipRoute
  '/create-squad': typeof gameCreateSquadRoute
  '/create-tournament': typeof gameCreateTournamentRoute
  '/home': typeof gameHomeRoute
  '/profile': typeof gameProfileRoute
  '/pvp': typeof gamePvpRoute
  '/squad': typeof gameSquadRoute
  '/top-performers': typeof gameTopPerformersRoute
  '/onboarding/create-wallet': typeof OnboardingCreateWalletRoute
  '/onboarding/login': typeof OnboardingLoginRoute
  '/arena/': typeof ArenaIndexRoute
  '/landing-page/': typeof LandingPageIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/privacy-policy/': typeof PrivacyPolicyIndexRoute
  '/responsible-gaming-policy/': typeof ResponsibleGamingPolicyIndexRoute
  '/terms-of-service/': typeof TermsOfServiceIndexRoute
  '/championship/$tournamentId': typeof gameChampionshipTournamentIdRoute
  '/gacha/history': typeof gameGachaHistoryRoute
  '/grand-rush/history': typeof gameGrandRushHistoryRoute
  '/grand-rush/leaderboard': typeof gameGrandRushLeaderboardRoute
  '/hosted-tournament/$tournamentId': typeof gameHostedTournamentTournamentIdRoute
  '/koth/$kothId': typeof gameKothKothIdRoute
  '/koth/history': typeof gameKothHistoryRoute
  '/koth/leaderboard': typeof gameKothLeaderboardRoute
  '/match/$seed': typeof gameMatchSeedRoute
  '/match/history': typeof gameMatchHistoryRoute
  '/missions/daily-mission': typeof gameMissionsDailyMissionRoute
  '/missions/onetime-mission': typeof gameMissionsOnetimeMissionRoute
  '/practice/history': typeof gamePracticeHistoryRoute
  '/practice/leaderboard': typeof gamePracticeLeaderboardRoute
  '/rush/history': typeof gameRushHistoryRoute
  '/rush/leaderboard': typeof gameRushLeaderboardRoute
  '/tournament/$tournamentId': typeof gameTournamentTournamentIdRoute
  '/winner-takes-all/$tournamentId': typeof gameWinnerTakesAllTournamentIdRoute
  '/winner-takes-all/history': typeof gameWinnerTakesAllHistoryRoute
  '/championship/': typeof gameChampionshipIndexRoute
  '/changelog/': typeof gameChangelogIndexRoute
  '/event/': typeof gameEventIndexRoute
  '/gacha-task/': typeof gameGachaTaskIndexRoute
  '/gacha/': typeof gameGachaIndexRoute
  '/grand-rush/': typeof gameGrandRushIndexRoute
  '/hosted-tournament/': typeof gameHostedTournamentIndexRoute
  '/inventory/': typeof gameInventoryIndexRoute
  '/koth/': typeof gameKothIndexRoute
  '/leaderboard/': typeof gameLeaderboardIndexRoute
  '/lucky-draw/': typeof gameLuckyDrawIndexRoute
  '/missions/': typeof gameMissionsIndexRoute
  '/practice/': typeof gamePracticeIndexRoute
  '/referrals/': typeof gameReferralsIndexRoute
  '/referrer/': typeof gameReferrerIndexRoute
  '/rush/': typeof gameRushIndexRoute
  '/shop/': typeof gameShopIndexRoute
  '/terminal/': typeof gameTerminalIndexRoute
  '/tournament/': typeof gameTournamentIndexRoute
  '/vip-program/': typeof gameVipProgramIndexRoute
  '/winner-takes-all/': typeof gameWinnerTakesAllIndexRoute
  '/lucky-draw/history/$drawId': typeof gameLuckyDrawHistoryDrawIdRoute
  '/private-championship/$tournamentId/$matchId': typeof gamePrivateChampionshipTournamentIdMatchIdRoute
  '/lucky-draw/history/': typeof gameLuckyDrawHistoryIndexRoute
  '/private-championship/$tournamentId/': typeof gamePrivateChampionshipTournamentIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/relay-test': typeof RelayTestRoute
  '/ui-showcase': typeof UiShowcaseRoute
  '/world': typeof WorldRoute
  '/create-championship': typeof gameCreateChampionshipRoute
  '/create-squad': typeof gameCreateSquadRoute
  '/create-tournament': typeof gameCreateTournamentRoute
  '/home': typeof gameHomeRoute
  '/profile': typeof gameProfileRoute
  '/pvp': typeof gamePvpRoute
  '/squad': typeof gameSquadRoute
  '/top-performers': typeof gameTopPerformersRoute
  '/onboarding/create-wallet': typeof OnboardingCreateWalletRoute
  '/onboarding/login': typeof OnboardingLoginRoute
  '/arena': typeof ArenaIndexRoute
  '/landing-page': typeof LandingPageIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/privacy-policy': typeof PrivacyPolicyIndexRoute
  '/responsible-gaming-policy': typeof ResponsibleGamingPolicyIndexRoute
  '/terms-of-service': typeof TermsOfServiceIndexRoute
  '/championship/$tournamentId': typeof gameChampionshipTournamentIdRoute
  '/gacha/history': typeof gameGachaHistoryRoute
  '/grand-rush/history': typeof gameGrandRushHistoryRoute
  '/grand-rush/leaderboard': typeof gameGrandRushLeaderboardRoute
  '/hosted-tournament/$tournamentId': typeof gameHostedTournamentTournamentIdRoute
  '/koth/$kothId': typeof gameKothKothIdRoute
  '/koth/history': typeof gameKothHistoryRoute
  '/koth/leaderboard': typeof gameKothLeaderboardRoute
  '/match/$seed': typeof gameMatchSeedRoute
  '/match/history': typeof gameMatchHistoryRoute
  '/missions/daily-mission': typeof gameMissionsDailyMissionRoute
  '/missions/onetime-mission': typeof gameMissionsOnetimeMissionRoute
  '/practice/history': typeof gamePracticeHistoryRoute
  '/practice/leaderboard': typeof gamePracticeLeaderboardRoute
  '/rush/history': typeof gameRushHistoryRoute
  '/rush/leaderboard': typeof gameRushLeaderboardRoute
  '/tournament/$tournamentId': typeof gameTournamentTournamentIdRoute
  '/winner-takes-all/$tournamentId': typeof gameWinnerTakesAllTournamentIdRoute
  '/winner-takes-all/history': typeof gameWinnerTakesAllHistoryRoute
  '/championship': typeof gameChampionshipIndexRoute
  '/changelog': typeof gameChangelogIndexRoute
  '/event': typeof gameEventIndexRoute
  '/gacha-task': typeof gameGachaTaskIndexRoute
  '/gacha': typeof gameGachaIndexRoute
  '/grand-rush': typeof gameGrandRushIndexRoute
  '/hosted-tournament': typeof gameHostedTournamentIndexRoute
  '/inventory': typeof gameInventoryIndexRoute
  '/koth': typeof gameKothIndexRoute
  '/leaderboard': typeof gameLeaderboardIndexRoute
  '/lucky-draw': typeof gameLuckyDrawIndexRoute
  '/missions': typeof gameMissionsIndexRoute
  '/practice': typeof gamePracticeIndexRoute
  '/referrals': typeof gameReferralsIndexRoute
  '/referrer': typeof gameReferrerIndexRoute
  '/rush': typeof gameRushIndexRoute
  '/shop': typeof gameShopIndexRoute
  '/terminal': typeof gameTerminalIndexRoute
  '/tournament': typeof gameTournamentIndexRoute
  '/vip-program': typeof gameVipProgramIndexRoute
  '/winner-takes-all': typeof gameWinnerTakesAllIndexRoute
  '/lucky-draw/history/$drawId': typeof gameLuckyDrawHistoryDrawIdRoute
  '/private-championship/$tournamentId/$matchId': typeof gamePrivateChampionshipTournamentIdMatchIdRoute
  '/lucky-draw/history': typeof gameLuckyDrawHistoryIndexRoute
  '/private-championship/$tournamentId': typeof gamePrivateChampionshipTournamentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(game)': typeof gameRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/relay-test': typeof RelayTestRoute
  '/ui-showcase': typeof UiShowcaseRoute
  '/world': typeof WorldRoute
  '/(game)/create-championship': typeof gameCreateChampionshipRoute
  '/(game)/create-squad': typeof gameCreateSquadRoute
  '/(game)/create-tournament': typeof gameCreateTournamentRoute
  '/(game)/home': typeof gameHomeRoute
  '/(game)/profile': typeof gameProfileRoute
  '/(game)/pvp': typeof gamePvpRoute
  '/(game)/squad': typeof gameSquadRoute
  '/(game)/top-performers': typeof gameTopPerformersRoute
  '/onboarding/create-wallet': typeof OnboardingCreateWalletRoute
  '/onboarding/login': typeof OnboardingLoginRoute
  '/arena/': typeof ArenaIndexRoute
  '/landing-page/': typeof LandingPageIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/privacy-policy/': typeof PrivacyPolicyIndexRoute
  '/responsible-gaming-policy/': typeof ResponsibleGamingPolicyIndexRoute
  '/terms-of-service/': typeof TermsOfServiceIndexRoute
  '/(game)/championship/$tournamentId': typeof gameChampionshipTournamentIdRoute
  '/(game)/gacha/history': typeof gameGachaHistoryRoute
  '/(game)/grand-rush/history': typeof gameGrandRushHistoryRoute
  '/(game)/grand-rush/leaderboard': typeof gameGrandRushLeaderboardRoute
  '/(game)/hosted-tournament/$tournamentId': typeof gameHostedTournamentTournamentIdRoute
  '/(game)/koth/$kothId': typeof gameKothKothIdRoute
  '/(game)/koth/history': typeof gameKothHistoryRoute
  '/(game)/koth/leaderboard': typeof gameKothLeaderboardRoute
  '/(game)/match/$seed': typeof gameMatchSeedRoute
  '/(game)/match/history': typeof gameMatchHistoryRoute
  '/(game)/missions/daily-mission': typeof gameMissionsDailyMissionRoute
  '/(game)/missions/onetime-mission': typeof gameMissionsOnetimeMissionRoute
  '/(game)/practice/history': typeof gamePracticeHistoryRoute
  '/(game)/practice/leaderboard': typeof gamePracticeLeaderboardRoute
  '/(game)/rush/history': typeof gameRushHistoryRoute
  '/(game)/rush/leaderboard': typeof gameRushLeaderboardRoute
  '/(game)/tournament/$tournamentId': typeof gameTournamentTournamentIdRoute
  '/(game)/winner-takes-all/$tournamentId': typeof gameWinnerTakesAllTournamentIdRoute
  '/(game)/winner-takes-all/history': typeof gameWinnerTakesAllHistoryRoute
  '/(game)/championship/': typeof gameChampionshipIndexRoute
  '/(game)/changelog/': typeof gameChangelogIndexRoute
  '/(game)/event/': typeof gameEventIndexRoute
  '/(game)/gacha-task/': typeof gameGachaTaskIndexRoute
  '/(game)/gacha/': typeof gameGachaIndexRoute
  '/(game)/grand-rush/': typeof gameGrandRushIndexRoute
  '/(game)/hosted-tournament/': typeof gameHostedTournamentIndexRoute
  '/(game)/inventory/': typeof gameInventoryIndexRoute
  '/(game)/koth/': typeof gameKothIndexRoute
  '/(game)/leaderboard/': typeof gameLeaderboardIndexRoute
  '/(game)/lucky-draw/': typeof gameLuckyDrawIndexRoute
  '/(game)/missions/': typeof gameMissionsIndexRoute
  '/(game)/practice/': typeof gamePracticeIndexRoute
  '/(game)/referrals/': typeof gameReferralsIndexRoute
  '/(game)/referrer/': typeof gameReferrerIndexRoute
  '/(game)/rush/': typeof gameRushIndexRoute
  '/(game)/shop/': typeof gameShopIndexRoute
  '/(game)/terminal/': typeof gameTerminalIndexRoute
  '/(game)/tournament/': typeof gameTournamentIndexRoute
  '/(game)/vip-program/': typeof gameVipProgramIndexRoute
  '/(game)/winner-takes-all/': typeof gameWinnerTakesAllIndexRoute
  '/(game)/lucky-draw/history/$drawId': typeof gameLuckyDrawHistoryDrawIdRoute
  '/(game)/private-championship/$tournamentId/$matchId': typeof gamePrivateChampionshipTournamentIdMatchIdRoute
  '/(game)/lucky-draw/history/': typeof gameLuckyDrawHistoryIndexRoute
  '/(game)/private-championship/$tournamentId/': typeof gamePrivateChampionshipTournamentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/relay-test'
    | '/ui-showcase'
    | '/world'
    | '/create-championship'
    | '/create-squad'
    | '/create-tournament'
    | '/home'
    | '/profile'
    | '/pvp'
    | '/squad'
    | '/top-performers'
    | '/onboarding/create-wallet'
    | '/onboarding/login'
    | '/arena/'
    | '/landing-page/'
    | '/onboarding/'
    | '/privacy-policy/'
    | '/responsible-gaming-policy/'
    | '/terms-of-service/'
    | '/championship/$tournamentId'
    | '/gacha/history'
    | '/grand-rush/history'
    | '/grand-rush/leaderboard'
    | '/hosted-tournament/$tournamentId'
    | '/koth/$kothId'
    | '/koth/history'
    | '/koth/leaderboard'
    | '/match/$seed'
    | '/match/history'
    | '/missions/daily-mission'
    | '/missions/onetime-mission'
    | '/practice/history'
    | '/practice/leaderboard'
    | '/rush/history'
    | '/rush/leaderboard'
    | '/tournament/$tournamentId'
    | '/winner-takes-all/$tournamentId'
    | '/winner-takes-all/history'
    | '/championship/'
    | '/changelog/'
    | '/event/'
    | '/gacha-task/'
    | '/gacha/'
    | '/grand-rush/'
    | '/hosted-tournament/'
    | '/inventory/'
    | '/koth/'
    | '/leaderboard/'
    | '/lucky-draw/'
    | '/missions/'
    | '/practice/'
    | '/referrals/'
    | '/referrer/'
    | '/rush/'
    | '/shop/'
    | '/terminal/'
    | '/tournament/'
    | '/vip-program/'
    | '/winner-takes-all/'
    | '/lucky-draw/history/$drawId'
    | '/private-championship/$tournamentId/$matchId'
    | '/lucky-draw/history/'
    | '/private-championship/$tournamentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/relay-test'
    | '/ui-showcase'
    | '/world'
    | '/create-championship'
    | '/create-squad'
    | '/create-tournament'
    | '/home'
    | '/profile'
    | '/pvp'
    | '/squad'
    | '/top-performers'
    | '/onboarding/create-wallet'
    | '/onboarding/login'
    | '/arena'
    | '/landing-page'
    | '/onboarding'
    | '/privacy-policy'
    | '/responsible-gaming-policy'
    | '/terms-of-service'
    | '/championship/$tournamentId'
    | '/gacha/history'
    | '/grand-rush/history'
    | '/grand-rush/leaderboard'
    | '/hosted-tournament/$tournamentId'
    | '/koth/$kothId'
    | '/koth/history'
    | '/koth/leaderboard'
    | '/match/$seed'
    | '/match/history'
    | '/missions/daily-mission'
    | '/missions/onetime-mission'
    | '/practice/history'
    | '/practice/leaderboard'
    | '/rush/history'
    | '/rush/leaderboard'
    | '/tournament/$tournamentId'
    | '/winner-takes-all/$tournamentId'
    | '/winner-takes-all/history'
    | '/championship'
    | '/changelog'
    | '/event'
    | '/gacha-task'
    | '/gacha'
    | '/grand-rush'
    | '/hosted-tournament'
    | '/inventory'
    | '/koth'
    | '/leaderboard'
    | '/lucky-draw'
    | '/missions'
    | '/practice'
    | '/referrals'
    | '/referrer'
    | '/rush'
    | '/shop'
    | '/terminal'
    | '/tournament'
    | '/vip-program'
    | '/winner-takes-all'
    | '/lucky-draw/history/$drawId'
    | '/private-championship/$tournamentId/$matchId'
    | '/lucky-draw/history'
    | '/private-championship/$tournamentId'
  id:
    | '__root__'
    | '/'
    | '/(game)'
    | '/about'
    | '/relay-test'
    | '/ui-showcase'
    | '/world'
    | '/(game)/create-championship'
    | '/(game)/create-squad'
    | '/(game)/create-tournament'
    | '/(game)/home'
    | '/(game)/profile'
    | '/(game)/pvp'
    | '/(game)/squad'
    | '/(game)/top-performers'
    | '/onboarding/create-wallet'
    | '/onboarding/login'
    | '/arena/'
    | '/landing-page/'
    | '/onboarding/'
    | '/privacy-policy/'
    | '/responsible-gaming-policy/'
    | '/terms-of-service/'
    | '/(game)/championship/$tournamentId'
    | '/(game)/gacha/history'
    | '/(game)/grand-rush/history'
    | '/(game)/grand-rush/leaderboard'
    | '/(game)/hosted-tournament/$tournamentId'
    | '/(game)/koth/$kothId'
    | '/(game)/koth/history'
    | '/(game)/koth/leaderboard'
    | '/(game)/match/$seed'
    | '/(game)/match/history'
    | '/(game)/missions/daily-mission'
    | '/(game)/missions/onetime-mission'
    | '/(game)/practice/history'
    | '/(game)/practice/leaderboard'
    | '/(game)/rush/history'
    | '/(game)/rush/leaderboard'
    | '/(game)/tournament/$tournamentId'
    | '/(game)/winner-takes-all/$tournamentId'
    | '/(game)/winner-takes-all/history'
    | '/(game)/championship/'
    | '/(game)/changelog/'
    | '/(game)/event/'
    | '/(game)/gacha-task/'
    | '/(game)/gacha/'
    | '/(game)/grand-rush/'
    | '/(game)/hosted-tournament/'
    | '/(game)/inventory/'
    | '/(game)/koth/'
    | '/(game)/leaderboard/'
    | '/(game)/lucky-draw/'
    | '/(game)/missions/'
    | '/(game)/practice/'
    | '/(game)/referrals/'
    | '/(game)/referrer/'
    | '/(game)/rush/'
    | '/(game)/shop/'
    | '/(game)/terminal/'
    | '/(game)/tournament/'
    | '/(game)/vip-program/'
    | '/(game)/winner-takes-all/'
    | '/(game)/lucky-draw/history/$drawId'
    | '/(game)/private-championship/$tournamentId/$matchId'
    | '/(game)/lucky-draw/history/'
    | '/(game)/private-championship/$tournamentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  gameRouteRoute: typeof gameRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  RelayTestRoute: typeof RelayTestRoute
  UiShowcaseRoute: typeof UiShowcaseRoute
  WorldRoute: typeof WorldRoute
  OnboardingCreateWalletRoute: typeof OnboardingCreateWalletRoute
  OnboardingLoginRoute: typeof OnboardingLoginRoute
  ArenaIndexRoute: typeof ArenaIndexRoute
  LandingPageIndexRoute: typeof LandingPageIndexRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  PrivacyPolicyIndexRoute: typeof PrivacyPolicyIndexRoute
  ResponsibleGamingPolicyIndexRoute: typeof ResponsibleGamingPolicyIndexRoute
  TermsOfServiceIndexRoute: typeof TermsOfServiceIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/world': {
      id: '/world'
      path: '/world'
      fullPath: '/world'
      preLoaderRoute: typeof WorldRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui-showcase': {
      id: '/ui-showcase'
      path: '/ui-showcase'
      fullPath: '/ui-showcase'
      preLoaderRoute: typeof UiShowcaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/relay-test': {
      id: '/relay-test'
      path: '/relay-test'
      fullPath: '/relay-test'
      preLoaderRoute: typeof RelayTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(game)': {
      id: '/(game)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof gameRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service/': {
      id: '/terms-of-service/'
      path: '/terms-of-service'
      fullPath: '/terms-of-service/'
      preLoaderRoute: typeof TermsOfServiceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/responsible-gaming-policy/': {
      id: '/responsible-gaming-policy/'
      path: '/responsible-gaming-policy'
      fullPath: '/responsible-gaming-policy/'
      preLoaderRoute: typeof ResponsibleGamingPolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy/': {
      id: '/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/privacy-policy/'
      preLoaderRoute: typeof PrivacyPolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/landing-page/': {
      id: '/landing-page/'
      path: '/landing-page'
      fullPath: '/landing-page/'
      preLoaderRoute: typeof LandingPageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arena/': {
      id: '/arena/'
      path: '/arena'
      fullPath: '/arena/'
      preLoaderRoute: typeof ArenaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/login': {
      id: '/onboarding/login'
      path: '/onboarding/login'
      fullPath: '/onboarding/login'
      preLoaderRoute: typeof OnboardingLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/create-wallet': {
      id: '/onboarding/create-wallet'
      path: '/onboarding/create-wallet'
      fullPath: '/onboarding/create-wallet'
      preLoaderRoute: typeof OnboardingCreateWalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(game)/top-performers': {
      id: '/(game)/top-performers'
      path: '/top-performers'
      fullPath: '/top-performers'
      preLoaderRoute: typeof gameTopPerformersRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/squad': {
      id: '/(game)/squad'
      path: '/squad'
      fullPath: '/squad'
      preLoaderRoute: typeof gameSquadRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/pvp': {
      id: '/(game)/pvp'
      path: '/pvp'
      fullPath: '/pvp'
      preLoaderRoute: typeof gamePvpRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/profile': {
      id: '/(game)/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof gameProfileRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/home': {
      id: '/(game)/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof gameHomeRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/create-tournament': {
      id: '/(game)/create-tournament'
      path: '/create-tournament'
      fullPath: '/create-tournament'
      preLoaderRoute: typeof gameCreateTournamentRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/create-squad': {
      id: '/(game)/create-squad'
      path: '/create-squad'
      fullPath: '/create-squad'
      preLoaderRoute: typeof gameCreateSquadRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/create-championship': {
      id: '/(game)/create-championship'
      path: '/create-championship'
      fullPath: '/create-championship'
      preLoaderRoute: typeof gameCreateChampionshipRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/winner-takes-all/': {
      id: '/(game)/winner-takes-all/'
      path: '/winner-takes-all'
      fullPath: '/winner-takes-all/'
      preLoaderRoute: typeof gameWinnerTakesAllIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/vip-program/': {
      id: '/(game)/vip-program/'
      path: '/vip-program'
      fullPath: '/vip-program/'
      preLoaderRoute: typeof gameVipProgramIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/tournament/': {
      id: '/(game)/tournament/'
      path: '/tournament'
      fullPath: '/tournament/'
      preLoaderRoute: typeof gameTournamentIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/terminal/': {
      id: '/(game)/terminal/'
      path: '/terminal'
      fullPath: '/terminal/'
      preLoaderRoute: typeof gameTerminalIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/shop/': {
      id: '/(game)/shop/'
      path: '/shop'
      fullPath: '/shop/'
      preLoaderRoute: typeof gameShopIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/rush/': {
      id: '/(game)/rush/'
      path: '/rush'
      fullPath: '/rush/'
      preLoaderRoute: typeof gameRushIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/referrer/': {
      id: '/(game)/referrer/'
      path: '/referrer'
      fullPath: '/referrer/'
      preLoaderRoute: typeof gameReferrerIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/referrals/': {
      id: '/(game)/referrals/'
      path: '/referrals'
      fullPath: '/referrals/'
      preLoaderRoute: typeof gameReferralsIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/practice/': {
      id: '/(game)/practice/'
      path: '/practice'
      fullPath: '/practice/'
      preLoaderRoute: typeof gamePracticeIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/missions/': {
      id: '/(game)/missions/'
      path: '/missions'
      fullPath: '/missions/'
      preLoaderRoute: typeof gameMissionsIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/lucky-draw/': {
      id: '/(game)/lucky-draw/'
      path: '/lucky-draw'
      fullPath: '/lucky-draw/'
      preLoaderRoute: typeof gameLuckyDrawIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/leaderboard/': {
      id: '/(game)/leaderboard/'
      path: '/leaderboard'
      fullPath: '/leaderboard/'
      preLoaderRoute: typeof gameLeaderboardIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/koth/': {
      id: '/(game)/koth/'
      path: '/koth'
      fullPath: '/koth/'
      preLoaderRoute: typeof gameKothIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/inventory/': {
      id: '/(game)/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof gameInventoryIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/hosted-tournament/': {
      id: '/(game)/hosted-tournament/'
      path: '/hosted-tournament'
      fullPath: '/hosted-tournament/'
      preLoaderRoute: typeof gameHostedTournamentIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/grand-rush/': {
      id: '/(game)/grand-rush/'
      path: '/grand-rush'
      fullPath: '/grand-rush/'
      preLoaderRoute: typeof gameGrandRushIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/gacha/': {
      id: '/(game)/gacha/'
      path: '/gacha'
      fullPath: '/gacha/'
      preLoaderRoute: typeof gameGachaIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/gacha-task/': {
      id: '/(game)/gacha-task/'
      path: '/gacha-task'
      fullPath: '/gacha-task/'
      preLoaderRoute: typeof gameGachaTaskIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/event/': {
      id: '/(game)/event/'
      path: '/event'
      fullPath: '/event/'
      preLoaderRoute: typeof gameEventIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/changelog/': {
      id: '/(game)/changelog/'
      path: '/changelog'
      fullPath: '/changelog/'
      preLoaderRoute: typeof gameChangelogIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/championship/': {
      id: '/(game)/championship/'
      path: '/championship'
      fullPath: '/championship/'
      preLoaderRoute: typeof gameChampionshipIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/winner-takes-all/history': {
      id: '/(game)/winner-takes-all/history'
      path: '/winner-takes-all/history'
      fullPath: '/winner-takes-all/history'
      preLoaderRoute: typeof gameWinnerTakesAllHistoryRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/winner-takes-all/$tournamentId': {
      id: '/(game)/winner-takes-all/$tournamentId'
      path: '/winner-takes-all/$tournamentId'
      fullPath: '/winner-takes-all/$tournamentId'
      preLoaderRoute: typeof gameWinnerTakesAllTournamentIdRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/tournament/$tournamentId': {
      id: '/(game)/tournament/$tournamentId'
      path: '/tournament/$tournamentId'
      fullPath: '/tournament/$tournamentId'
      preLoaderRoute: typeof gameTournamentTournamentIdRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/rush/leaderboard': {
      id: '/(game)/rush/leaderboard'
      path: '/rush/leaderboard'
      fullPath: '/rush/leaderboard'
      preLoaderRoute: typeof gameRushLeaderboardRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/rush/history': {
      id: '/(game)/rush/history'
      path: '/rush/history'
      fullPath: '/rush/history'
      preLoaderRoute: typeof gameRushHistoryRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/practice/leaderboard': {
      id: '/(game)/practice/leaderboard'
      path: '/practice/leaderboard'
      fullPath: '/practice/leaderboard'
      preLoaderRoute: typeof gamePracticeLeaderboardRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/practice/history': {
      id: '/(game)/practice/history'
      path: '/practice/history'
      fullPath: '/practice/history'
      preLoaderRoute: typeof gamePracticeHistoryRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/missions/onetime-mission': {
      id: '/(game)/missions/onetime-mission'
      path: '/missions/onetime-mission'
      fullPath: '/missions/onetime-mission'
      preLoaderRoute: typeof gameMissionsOnetimeMissionRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/missions/daily-mission': {
      id: '/(game)/missions/daily-mission'
      path: '/missions/daily-mission'
      fullPath: '/missions/daily-mission'
      preLoaderRoute: typeof gameMissionsDailyMissionRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/match/history': {
      id: '/(game)/match/history'
      path: '/match/history'
      fullPath: '/match/history'
      preLoaderRoute: typeof gameMatchHistoryRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/match/$seed': {
      id: '/(game)/match/$seed'
      path: '/match/$seed'
      fullPath: '/match/$seed'
      preLoaderRoute: typeof gameMatchSeedRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/koth/leaderboard': {
      id: '/(game)/koth/leaderboard'
      path: '/koth/leaderboard'
      fullPath: '/koth/leaderboard'
      preLoaderRoute: typeof gameKothLeaderboardRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/koth/history': {
      id: '/(game)/koth/history'
      path: '/koth/history'
      fullPath: '/koth/history'
      preLoaderRoute: typeof gameKothHistoryRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/koth/$kothId': {
      id: '/(game)/koth/$kothId'
      path: '/koth/$kothId'
      fullPath: '/koth/$kothId'
      preLoaderRoute: typeof gameKothKothIdRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/hosted-tournament/$tournamentId': {
      id: '/(game)/hosted-tournament/$tournamentId'
      path: '/hosted-tournament/$tournamentId'
      fullPath: '/hosted-tournament/$tournamentId'
      preLoaderRoute: typeof gameHostedTournamentTournamentIdRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/grand-rush/leaderboard': {
      id: '/(game)/grand-rush/leaderboard'
      path: '/grand-rush/leaderboard'
      fullPath: '/grand-rush/leaderboard'
      preLoaderRoute: typeof gameGrandRushLeaderboardRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/grand-rush/history': {
      id: '/(game)/grand-rush/history'
      path: '/grand-rush/history'
      fullPath: '/grand-rush/history'
      preLoaderRoute: typeof gameGrandRushHistoryRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/gacha/history': {
      id: '/(game)/gacha/history'
      path: '/gacha/history'
      fullPath: '/gacha/history'
      preLoaderRoute: typeof gameGachaHistoryRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/championship/$tournamentId': {
      id: '/(game)/championship/$tournamentId'
      path: '/championship/$tournamentId'
      fullPath: '/championship/$tournamentId'
      preLoaderRoute: typeof gameChampionshipTournamentIdRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/private-championship/$tournamentId/': {
      id: '/(game)/private-championship/$tournamentId/'
      path: '/private-championship/$tournamentId'
      fullPath: '/private-championship/$tournamentId/'
      preLoaderRoute: typeof gamePrivateChampionshipTournamentIdIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/lucky-draw/history/': {
      id: '/(game)/lucky-draw/history/'
      path: '/lucky-draw/history'
      fullPath: '/lucky-draw/history/'
      preLoaderRoute: typeof gameLuckyDrawHistoryIndexRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/private-championship/$tournamentId/$matchId': {
      id: '/(game)/private-championship/$tournamentId/$matchId'
      path: '/private-championship/$tournamentId/$matchId'
      fullPath: '/private-championship/$tournamentId/$matchId'
      preLoaderRoute: typeof gamePrivateChampionshipTournamentIdMatchIdRouteImport
      parentRoute: typeof gameRouteRoute
    }
    '/(game)/lucky-draw/history/$drawId': {
      id: '/(game)/lucky-draw/history/$drawId'
      path: '/lucky-draw/history/$drawId'
      fullPath: '/lucky-draw/history/$drawId'
      preLoaderRoute: typeof gameLuckyDrawHistoryDrawIdRouteImport
      parentRoute: typeof gameRouteRoute
    }
  }
}

interface gameRouteRouteChildren {
  gameCreateChampionshipRoute: typeof gameCreateChampionshipRoute
  gameCreateSquadRoute: typeof gameCreateSquadRoute
  gameCreateTournamentRoute: typeof gameCreateTournamentRoute
  gameHomeRoute: typeof gameHomeRoute
  gameProfileRoute: typeof gameProfileRoute
  gamePvpRoute: typeof gamePvpRoute
  gameSquadRoute: typeof gameSquadRoute
  gameTopPerformersRoute: typeof gameTopPerformersRoute
  gameChampionshipTournamentIdRoute: typeof gameChampionshipTournamentIdRoute
  gameGachaHistoryRoute: typeof gameGachaHistoryRoute
  gameGrandRushHistoryRoute: typeof gameGrandRushHistoryRoute
  gameGrandRushLeaderboardRoute: typeof gameGrandRushLeaderboardRoute
  gameHostedTournamentTournamentIdRoute: typeof gameHostedTournamentTournamentIdRoute
  gameKothKothIdRoute: typeof gameKothKothIdRoute
  gameKothHistoryRoute: typeof gameKothHistoryRoute
  gameKothLeaderboardRoute: typeof gameKothLeaderboardRoute
  gameMatchSeedRoute: typeof gameMatchSeedRoute
  gameMatchHistoryRoute: typeof gameMatchHistoryRoute
  gameMissionsDailyMissionRoute: typeof gameMissionsDailyMissionRoute
  gameMissionsOnetimeMissionRoute: typeof gameMissionsOnetimeMissionRoute
  gamePracticeHistoryRoute: typeof gamePracticeHistoryRoute
  gamePracticeLeaderboardRoute: typeof gamePracticeLeaderboardRoute
  gameRushHistoryRoute: typeof gameRushHistoryRoute
  gameRushLeaderboardRoute: typeof gameRushLeaderboardRoute
  gameTournamentTournamentIdRoute: typeof gameTournamentTournamentIdRoute
  gameWinnerTakesAllTournamentIdRoute: typeof gameWinnerTakesAllTournamentIdRoute
  gameWinnerTakesAllHistoryRoute: typeof gameWinnerTakesAllHistoryRoute
  gameChampionshipIndexRoute: typeof gameChampionshipIndexRoute
  gameChangelogIndexRoute: typeof gameChangelogIndexRoute
  gameEventIndexRoute: typeof gameEventIndexRoute
  gameGachaTaskIndexRoute: typeof gameGachaTaskIndexRoute
  gameGachaIndexRoute: typeof gameGachaIndexRoute
  gameGrandRushIndexRoute: typeof gameGrandRushIndexRoute
  gameHostedTournamentIndexRoute: typeof gameHostedTournamentIndexRoute
  gameInventoryIndexRoute: typeof gameInventoryIndexRoute
  gameKothIndexRoute: typeof gameKothIndexRoute
  gameLeaderboardIndexRoute: typeof gameLeaderboardIndexRoute
  gameLuckyDrawIndexRoute: typeof gameLuckyDrawIndexRoute
  gameMissionsIndexRoute: typeof gameMissionsIndexRoute
  gamePracticeIndexRoute: typeof gamePracticeIndexRoute
  gameReferralsIndexRoute: typeof gameReferralsIndexRoute
  gameReferrerIndexRoute: typeof gameReferrerIndexRoute
  gameRushIndexRoute: typeof gameRushIndexRoute
  gameShopIndexRoute: typeof gameShopIndexRoute
  gameTerminalIndexRoute: typeof gameTerminalIndexRoute
  gameTournamentIndexRoute: typeof gameTournamentIndexRoute
  gameVipProgramIndexRoute: typeof gameVipProgramIndexRoute
  gameWinnerTakesAllIndexRoute: typeof gameWinnerTakesAllIndexRoute
  gameLuckyDrawHistoryDrawIdRoute: typeof gameLuckyDrawHistoryDrawIdRoute
  gamePrivateChampionshipTournamentIdMatchIdRoute: typeof gamePrivateChampionshipTournamentIdMatchIdRoute
  gameLuckyDrawHistoryIndexRoute: typeof gameLuckyDrawHistoryIndexRoute
  gamePrivateChampionshipTournamentIdIndexRoute: typeof gamePrivateChampionshipTournamentIdIndexRoute
}

const gameRouteRouteChildren: gameRouteRouteChildren = {
  gameCreateChampionshipRoute: gameCreateChampionshipRoute,
  gameCreateSquadRoute: gameCreateSquadRoute,
  gameCreateTournamentRoute: gameCreateTournamentRoute,
  gameHomeRoute: gameHomeRoute,
  gameProfileRoute: gameProfileRoute,
  gamePvpRoute: gamePvpRoute,
  gameSquadRoute: gameSquadRoute,
  gameTopPerformersRoute: gameTopPerformersRoute,
  gameChampionshipTournamentIdRoute: gameChampionshipTournamentIdRoute,
  gameGachaHistoryRoute: gameGachaHistoryRoute,
  gameGrandRushHistoryRoute: gameGrandRushHistoryRoute,
  gameGrandRushLeaderboardRoute: gameGrandRushLeaderboardRoute,
  gameHostedTournamentTournamentIdRoute: gameHostedTournamentTournamentIdRoute,
  gameKothKothIdRoute: gameKothKothIdRoute,
  gameKothHistoryRoute: gameKothHistoryRoute,
  gameKothLeaderboardRoute: gameKothLeaderboardRoute,
  gameMatchSeedRoute: gameMatchSeedRoute,
  gameMatchHistoryRoute: gameMatchHistoryRoute,
  gameMissionsDailyMissionRoute: gameMissionsDailyMissionRoute,
  gameMissionsOnetimeMissionRoute: gameMissionsOnetimeMissionRoute,
  gamePracticeHistoryRoute: gamePracticeHistoryRoute,
  gamePracticeLeaderboardRoute: gamePracticeLeaderboardRoute,
  gameRushHistoryRoute: gameRushHistoryRoute,
  gameRushLeaderboardRoute: gameRushLeaderboardRoute,
  gameTournamentTournamentIdRoute: gameTournamentTournamentIdRoute,
  gameWinnerTakesAllTournamentIdRoute: gameWinnerTakesAllTournamentIdRoute,
  gameWinnerTakesAllHistoryRoute: gameWinnerTakesAllHistoryRoute,
  gameChampionshipIndexRoute: gameChampionshipIndexRoute,
  gameChangelogIndexRoute: gameChangelogIndexRoute,
  gameEventIndexRoute: gameEventIndexRoute,
  gameGachaTaskIndexRoute: gameGachaTaskIndexRoute,
  gameGachaIndexRoute: gameGachaIndexRoute,
  gameGrandRushIndexRoute: gameGrandRushIndexRoute,
  gameHostedTournamentIndexRoute: gameHostedTournamentIndexRoute,
  gameInventoryIndexRoute: gameInventoryIndexRoute,
  gameKothIndexRoute: gameKothIndexRoute,
  gameLeaderboardIndexRoute: gameLeaderboardIndexRoute,
  gameLuckyDrawIndexRoute: gameLuckyDrawIndexRoute,
  gameMissionsIndexRoute: gameMissionsIndexRoute,
  gamePracticeIndexRoute: gamePracticeIndexRoute,
  gameReferralsIndexRoute: gameReferralsIndexRoute,
  gameReferrerIndexRoute: gameReferrerIndexRoute,
  gameRushIndexRoute: gameRushIndexRoute,
  gameShopIndexRoute: gameShopIndexRoute,
  gameTerminalIndexRoute: gameTerminalIndexRoute,
  gameTournamentIndexRoute: gameTournamentIndexRoute,
  gameVipProgramIndexRoute: gameVipProgramIndexRoute,
  gameWinnerTakesAllIndexRoute: gameWinnerTakesAllIndexRoute,
  gameLuckyDrawHistoryDrawIdRoute: gameLuckyDrawHistoryDrawIdRoute,
  gamePrivateChampionshipTournamentIdMatchIdRoute:
    gamePrivateChampionshipTournamentIdMatchIdRoute,
  gameLuckyDrawHistoryIndexRoute: gameLuckyDrawHistoryIndexRoute,
  gamePrivateChampionshipTournamentIdIndexRoute:
    gamePrivateChampionshipTournamentIdIndexRoute,
}

const gameRouteRouteWithChildren = gameRouteRoute._addFileChildren(
  gameRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  gameRouteRoute: gameRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  RelayTestRoute: RelayTestRoute,
  UiShowcaseRoute: UiShowcaseRoute,
  WorldRoute: WorldRoute,
  OnboardingCreateWalletRoute: OnboardingCreateWalletRoute,
  OnboardingLoginRoute: OnboardingLoginRoute,
  ArenaIndexRoute: ArenaIndexRoute,
  LandingPageIndexRoute: LandingPageIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  PrivacyPolicyIndexRoute: PrivacyPolicyIndexRoute,
  ResponsibleGamingPolicyIndexRoute: ResponsibleGamingPolicyIndexRoute,
  TermsOfServiceIndexRoute: TermsOfServiceIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
